module.exports = __webpack_public_path__ + "img/full5-min.a1639351.png";